export default "__VITE_ASSET__D_hA6U1p__"